const dictionary = {
  "error.specialContact.mobile.duplicated": "مخاطبی با این شماره موبایل موجود است.",
  "error.order.orderItem.sku.not_existInWarehouse": "کالایی با این کدتنوع در انبار وجود ندارد.",
  "error.product.inventoryItem.used": "حداقل یک آیتم از این کالا استفاده شده است.",
  "error.product.code.duplicated": "کد کالا تکراری است.",
  "error.product.status.approved": "این کالا قبلا تایید شده است.",
  "error.product.tagId.notFound": "یک یا چند تگ از این کالا یافت نشد.",
  "error.product.id.notFound": "کالایی با این شناسه یافت نشد.",
  "error.product.id.null": "شناسه کالا خالی است.",
  "error.product.sku.feature.invalid": "ویژگی انتخابی برای این تنوع نامعتبر است.",
  "error.product.sku.used": "تنوع کالا قبلا استفاده شده است.",
  "error.product.sku.feature.used": "ویژگی تنوع کالا قبلا استفاده شده است.",
  "error.product.partnerId.null": "شناسه شرکت خالی است.",
  "error.product.partner.undefined": "شرکت تعریف نشده است.",
  "error.product.warehouseInventory.error": "کد کالا یا تنوع نامعتبر است.",
  "error.product.imageFile.notSaved": "عکس کالا ذخیره نشد.",
  "error.product.imageFile.invalid": "عکس کالا نامعتبر است.",
  "error.order.partner.undefined": "شرکت یافت نشد.",
  "error.sku.partner.invalid": "بعضی از کالاها برای این شرکت نیست.",
  "error.sku.seller.invalid": "بعضی از کالاها برای این فروشنده نیست.",
  "error.order.product.undefined": "کالایی یافت نشد.",
  "error.order.deliveryType.invalid": "ناوگان حمل نامعتبر است.",
  "error.order.paymentType.invalid": "پرداخت درب محل برای این ناوگان فعال نیست.",
  "error.order.cod.empty": "مقدار پرداخت درب محل خالی است.",
  "error.order.orderType.ToCenter.invalid": "مقادیر وارد شده برای این نوع سفارش اشتباه است.",
  "error.order.orderType.FromCenter.invalid": "مقادیر وارد شده برای این نوع سفارش اشتباه است.",
  "error.order.orderType.WithoutCenter.invalid": "مقادیر وارد شده برای این نوع سفارش اشتباه است.",
  "error.order.warehouse.null": "انبار برای سفارش انتخاب نشده است.",
  "order.trackingCode.duplicate": "کد پیگیری تکراری است.",
  "order.deliveryDate.beforeNow": "تاریخ تحویل قبل از امروز است",
  "order.trackingCode.notExist": "کد پیگیری وارد نشده است.",
  "order.status.invalidUpdate": "سفارش به این وضعیت قابل تغییر نیست.",
  "order.item.add.invalidOrderType": "افزودن آیتم به سفارش ممکن نیست.",
  "order.trackingCode.update.forbidden": "کد پیگیری قابل ویرایش نیست.",
  "order.partner.empty": "شرکت ثبت کننده سفارش یافت نشد.",
  "order.access.denied": "دسترسی به این سفارش امکان پذیر نیست.",
  "order.product.notUnique": "انتخاب تنوع کالا الزامی است.",
  "order.trackingCode.notUnique": "کد پیگیری تکراری است.",
  "order.center.redundant": "فقط یک مرکز انتخاب شود.",
  "order.center.null": "مرکز یافت نشد.",
  "order.center.code.invalid": "کد مرکز نامعتبر است.",
  "order.item.productCode.invalid": "کد کالای آیتم نامعتبر است.",
  "order.status.forbidden": "تبدیل وضعیت ممنوع است.",
  "order.inventoryItem.notExist": "آیتم این سفارش وجود ندارد.",
  "order.warehouse.unit.notExist": "یونیت انبار وجود ندارد.",
  "order.warehouse.empty": "انبار خالی است.",
  "order.id.notFound": "آیدی سفارش یافت نشد.",
  "order.deliveryType.notAllowed": "ناوگان حمل قابل انتخاب نیست.",
  "order.deliveryType.notAcceptable": "ناوگان حمل قابل قبول نیست.",
  "error.order.status.invalidUpdate": "در این وضعیت امکان ویرایش سفارش وجود ندارد.",
  "error.status.change": "در این وضعیت امکان ویرایش سفارش وجود ندارد.",
  "error.order.deliveryDate.holiday": "ثبت سفارش در روزهای تعطیل امکان پذیر نیست.",
  "error.duplicate.code": "کد کالا تکراری است.",
  "error.duplicate.name": "نام کالا تکراری است.",
  "parcel.deliveryTime.afterFourteen": "ثبت محموله تا قبل از ساعت ۱۴ امروز مجاز است.",
  "parcel.startDeliveryTime.beforeNow": "بازه تحویل قبل از ساعت فعلی است.",
  "parcel.deliveryDate.holiday": "ثبت محموله در روزهای تعطیل امکان پذیر نیست.",
  "error.parcel.deliveryTime.afterFourteen": "ثبت محموله تا قبل از ساعت ۱۴ امروز مجاز است.",
  "error.parcel.startDeliveryTime.beforeNow": "بازه تحویل قبل از ساعت فعلی است.",
  "error.parcel.deliveryDate.holiday": "ثبت محموله در روزهای تعطیل امکان پذیر نیست.",
  'error.order.trackingCode.duplicate': 'کد پیگیری تکراری است.'
}


export default function(text: keyof typeof dictionary) {
  return dictionary[text] || text
}